module.exports = __webpack_public_path__ + "static/media/imgExambleBenificio.03bafec8.jpeg";